import { Switch } from 'react-router-dom';
import PrivateRoute from 'components/atoms/routes/privateRoute';
import AppPage from 'pages/app';
import path from 'constants/paths';

// these routes are only for the initialization.
// if you want to add new routes, do it in AppPage component `src/pages/app/index.js`
function App() {
  return (
    <Switch>
      <PrivateRoute path={path.dashboard} component={AppPage} />
    </Switch>
  );
}

export default App;
